<template>
  <div>
    <van-popup :value="showCouponPopup" :close-on-click-overlay="false" @click-overlay="clickClose" class="receive">
      <div class="receive-box">
        <div class="receive-info">
          <!-- 选择车系开始 -->
          <template>
            <div class="receive-title-many">选择您的意向车系</div>
            <div class="receive-select">
              <div class="receive-many" @click="clickSeries">
                <span>{{ seriesSelected.name }}</span>
                <!-- <span>选择车系</span> -->
                <img src="@this/assets/image-14.png" />
              </div>
            </div>
            <van-checkbox
              v-if="showAgreement"
              v-model="isChecked"
              :label-disabled="true"
              checked-color="#ffffff"
              shape="square"
              class="checkPink"
            >
              <div class="checkYue" @click="gotoAgreement">我已阅读并同意隐私政策</div>
            </van-checkbox>
            <!-- 立即领取 -->
            <div class="receive-coupon-get" @click="clickReceive"></div>
          </template>
          <!-- 选择车系结束 -->
        </div>
      </div>
      <div @click="clickClose" class="popup-close-blue"></div>
    </van-popup>
    <!-- 多车系时选择意向车型弹窗 -->
    <van-popup :value="showSeriesPopup" :overlay="false" position="bottom" get-container="body" class="popup">
      <van-picker
        :columns="seriesList"
        value-key="name"
        defaultIndex="0"
        show-toolbar
        cancel-button-text="取消"
        @confirm="clickReceive"
        @cancel="clickSeries"
        @change="selectSeries"
      />
    </van-popup>
  </div>
</template>

<script>
import { Popup, Picker, Checkbox } from 'vant';

export default {
  props: {
    showCouponPopup: {
      type: Boolean,
      default: false,
    },
    showSeriesPopup: {
      type: Boolean,
      default: false,
    },
    seriesList: {
      type: Array,
      default() {
        return [];
      },
    },
    seriesSelected: {
      type: Object,
      default() {
        return {};
      },
    },
    showAgreement: {
      type: Boolean,
      default: true,
    },
    agreementChecked: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isChecked: {
      get() {
        return this.agreementChecked;
      },
      set(value) {
        this.$emit('changeAgreementChecked', value);
      },
    },
  },
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Checkbox.name]: Checkbox,
  },
  methods: {
    clickClose() {
      this.$emit('clickClose');
    },
    clickSeries() {
      this.$emit('clickSeries');
    },
    selectSeries(vm, series) {
      this.$emit('selectSeries', series);
    },
    gotoAgreement() {
      this.$emit('gotoAgreement');
    },
    clickReceive() {
      this.$emit('clickReceive');
    },
  },
};
</script>

<style lang="scss" scoped>
// 车系弹窗开始
.receive {
  .receive-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    .receive-info {
      background: url(~@this/assets/image-13.png) center top/contain no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 530px;
      min-height: 343px;
      padding: 50px 65px 65px;
    }
  }
}
.receive-title-many {
  font-size: 45px;
  font-weight: 800;
  color: #ffffff;
}
.receive-select {
  background-color: #ffffff;
  width: 95%;
  height: 100px;
  line-height: 100px;
  margin-top: 100px;
  padding: 0 20px;
  border-radius: 10px;
  margin-top: 50px;
  border: 1px solid #ceefff;
  .receive-many {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    > span {
      color: #1564c8;
      font-size: 45px;
      font-weight: 600;
    }
    > img {
      width: 33px;
      height: 17px;
    }
  }
}
.checkPink ::v-deep {
  align-self: start;
  height: 70px !important;
  .van-icon {
    background-color: #ffffff;
    border: 1px solid #1564c8 !important;
    border-radius: 2px;
  }
  .van-checkbox__icon--checked .van-icon {
    color: #1564c8;
  }
  .checkYue {
    color: #1564c8;
  }
}
.receive-coupon-get {
  background: url(~@this/assets/image-10.png) center top/contain no-repeat;
  background-size: 100% 100%;
  width: 338px;
  height: 100px;
  margin-top: 30px;
}
// 车系弹窗结束
</style>
